import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.996 2.721-.68.094.093-.68a.69.69 0 0 1 .587.586m-4.57 6.576a1.833 1.833 0 1 0-2.592-2.593 1.833 1.833 0 0 0 2.592 2.593"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.826 12.633a39 39 0 0 0-.354 1.326l-.065.274-.017.074-.005.02v.005l-.001.002.671.148-.671-.148a.69.69 0 0 0 .185.635l2.593 2.592a.69.69 0 0 0 .634.185l-.148-.67.148.67.008-.001.02-.005.073-.017q.096-.021.274-.065a35 35 0 0 0 1.326-.354l2.095 2.095a2.062 2.062 0 0 0 3.336-.605l2.28-5.016c.56-.457 1.046-.964 1.395-1.526 1.14-1.836 1.47-4.255 1.533-6.135a23 23 0 0 0-.107-3.123l-.023-.198-.007-.054-.002-.014V2.72l-.682.094.094-.68-.002-.001h-.004l-.015-.003-.054-.007-.198-.022a23 23 0 0 0-3.123-.108c-1.88.064-4.299.393-6.135 1.534-.562.348-1.07.833-1.526 1.394l-5.016 2.28a2.062 2.062 0 0 0-.605 3.336zm.458-1.487c.138-.418.292-.858.46-1.309a25 25 0 0 1 1.23-2.779L3.905 8.454a.687.687 0 0 0-.202 1.112zm3.943-5.112a11 11 0 0 0-.624.933c-.615 1.021-1.14 2.21-1.571 3.354a36 36 0 0 0-1.22 3.946l2.05 2.05a36 36 0 0 0 3.946-1.22c1.145-.429 2.334-.955 3.356-1.57q.506-.303.932-.624v-.002l.001.001c.584-.44 1.043-.901 1.338-1.375.945-1.522 1.265-3.64 1.327-5.457a22 22 0 0 0-.071-2.63q-.165-.015-.37-.03a22 22 0 0 0-2.26-.042c-1.817.062-3.936.382-5.458 1.327-.473.295-.935.754-1.375 1.338zm4.45 12.191 1.395-3.07c-.904.477-1.867.887-2.78 1.23-.45.17-.89.323-1.308.461l1.58 1.58c.34.34.914.236 1.113-.2",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.055 17.075a1.833 1.833 0 1 1-2.592 2.593 1.833 1.833 0 0 1 2.592-2.593"
    }, null, -1)
  ]))]))
}
export default { render: render }